import React, {Fragment} from 'react'
import PropTypes from 'prop-types'
import {Collapse} from 'react-collapse'
import {i18n} from '../../../Utils'
import styled from 'styled-components'
import SVG from '../../Presentational/Atoms/SVG'
import debounce from 'debounce'

class ExpandableSection extends React.Component {
    constructor (props) {
        super(props)
        this.state = {
            isOpened: false,
            windowWidth: window && window.innerWidth,
            isMobile: false,
        }
        this.onResize = debounce(this.onResize, 200)
    }

    componentDidMount() {
        if( typeof window !== 'undefined' ) {
            window.addEventListener('resize', this.onResize, false)
            this.handleMobile()
        }
    }

    componentWillUnmount() {
        if( typeof window !== 'undefined' ) {
            window.removeEventListener('resize', this.onResize)
        }
    }

    handleMobile = () => {
        if (this.state.windowWidth < 768) {
            this.setState({
                isMobile: true,
            })
        } else {
            this.setState({
                isMobile: false,
            })
        }
    }

    onResize = (event) => {
        this.setState({
            windowWidth: event.target.innerWidth,
        }, this.handleMobile)
    }

    toggle = () => {
        if (this.state.isMobile) {
            this.setState({
                isOpened: !this.state.isOpened,
            })
        }
    }

    render () {
        const {
            isOpened,
            isMobile,
        } = this.state

        const {
            toggleLinkLabel,
            labelColor,
            onInfoClick,
            children,
        } = this.props

        return (
            <Fragment>
                <Span color={labelColor}>
                    <span onClick={this.toggle}>
                        {isMobile &&
                            <Arrow color={labelColor} active={isOpened}>
                                <SVG icon={'chevronRight'}/>
                            </Arrow>}
                        {i18n(toggleLinkLabel, {}, true)}
                    </span>
                    <Info onClick={onInfoClick}>
                        <SVG icon={'info'}/>
                    </Info>
                </Span>
                <Container>
                    {isMobile && <Collapse isOpened={isOpened}>
                        <Border>
                            {children}
                        </Border>
                    </Collapse>}
                    {!isMobile &&
                        <Border>
                            {children}
                        </Border>}
                </Container>
            </Fragment>
        )
    }
}

ExpandableSection.propTypes = {
    toggleLinkLabel: PropTypes.string.isRequired,
    labelColor: PropTypes.string,
    onInfoClick: PropTypes.func,
}
export default ExpandableSection

const Arrow = styled.span`
    display: inline-block;
    height: 22px;
    width: 18px;
    position: relative;
    svg {
        height: 25px;
        font-size: 12px;
        transition: transform .5s ease;
        display: inline-block;
        margin-left: -8px;
        top: 3px;
        position: absolute;
        ${props => props.active && 'transform: rotate(90deg);'}
    }
`

const Info = styled.span`
    display: inline-block;
    height: 22px;
    width: 18px;
    position: relative;
    svg {
        height: 17px;
        font-size: 12px;
        transition: transform .5s ease;
        display: inline-block;
        margin-left: 5px;
        cursor: pointer;
        top: 7px;
        position: absolute;
        ${props => props.active && 'transform: rotate(90deg);'}
    }
`

const Container = styled.div`
    padding-top: 10px;
`

const Span = styled.span`
    color: ${props => props.color ? props.color : 'black'};
    font-size: 18px;
    font-weight: 200;
`

const Border = styled.div`
    border: 1px dotted #d9e2e9;
    border-left-color: transparent;
    border-right-color: transparent;
    padding-bottom: 20px;
`



// WEBPACK FOOTER //
// ./src/jsx/Components/Container/Molecules/ExpandableSection.jsx